import styled from 'styled-components'
import { PROGRESS_AREA_HEIGHT } from '~/app/components/Header'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { anatomyRootCss } from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    margin-top: ${PROGRESS_AREA_HEIGHT}px;
    height: calc(100% - ${PROGRESS_AREA_HEIGHT}px);

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  ImageWrapper: styled.div`
    max-width: 100%;
    border-radius: 0 0 16px 16px;

    picture {
      display: block;
      width: 100%;
    }

    img {
      max-width: 100%;
      width: 100%;
      display: block;
    }
  `,

  Title: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    color: ${COLORS.BLACK};
    margin-top: 16px;
    margin-bottom: 16px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.p`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;

    strong {
      font-weight: 700;
    }
  `,

  StyledButton: styled(Button)`
    margin-top: auto;
  `,
} as const
